import React from 'react'


export const Line = (props) => {
  return (
   <>
   <div {...props}>
   <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 115.67 15.75"
  >
    <path
      d="M102 15.75 89.25 3.39 76.62 15.63 63.97 3.37 51.55 15.42 38.9 3.15 25.92 15.74 13.11 3.32 1.57 14.5 0 12.88 13.11.17l12.81 12.42L38.9 0l12.65 12.27L63.97.22l12.65 12.26L89.25.23 102 12.59 114.09.87l1.58 1.62L102 15.75z"
      style={{
        strokeWidth: 0,
      }}
    />
  </svg>
  </div>
   </>
  )
}
